import { render, staticRenderFns } from "./ClientSection.vue?vue&type=template&id=73a2c6d1&scoped=true&"
import script from "./ClientSection.vue?vue&type=script&lang=js&"
export * from "./ClientSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a2c6d1",
  null
  
)

export default component.exports